import axiosApi from "../axiosInstance";

const systemCheck = async (request) => {
    try {
        request = request || {};
        const response = await axiosApi.post(`SystemCheck/SystemCheck`, request);
        return response?.data;
    } catch (error) {
        console.log("Error systemCheck===>:", error);
    }
};

export const SystemCheckService = {
    systemCheck,

}